import { render, staticRenderFns } from "./job-view.vue?vue&type=template&id=28fa423e&scoped=true&"
import script from "./job-view.vue?vue&type=script&lang=js&"
export * from "./job-view.vue?vue&type=script&lang=js&"
import style0 from "./job-view.vue?vue&type=style&index=0&id=28fa423e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa423e",
  null
  
)

component.options.__file = "job-view.vue"
export default component.exports